const menuIcon = $('#js-burger-icon')
const globalNav = $('#js-gnav')
const menuOverlay = $('#js-menu-overlay')
const wrapper = $('#js-wrapper')
let scrollPosition

function menuOpen() {
  scrollPosition = $(window).scrollTop()
  wrapper.addClass('is-fixed').css({ top: -scrollPosition })
  globalNav.removeAttr('aria-hidden')
  menuIcon.attr('aria-checked', 'true')
  menuOverlay.removeAttr('aria-hidden')
}

function menuClose() {
  wrapper.removeClass('is-fixed').css({ top: 0 })
  window.scrollTo(0, scrollPosition)
  globalNav.attr('aria-hidden', 'true')
  menuIcon.attr('aria-checked', 'false')
  menuOverlay.attr('aria-hidden', 'true')
}

$('[data-menu-toggle]').click(function() {
  if (globalNav.is('[aria-hidden]')) {
    menuOpen()
  } else {
    menuClose()
  }
})

$('[data-menu-close]').click(function() {
  menuClose()
})
